import Axios from "axios";
import utils from "@/utils/utils";

let store = {
    namespaced: true,
    state: {},
    actions: {},
    mutations: {},
    getters: {}
}

store.actions["GET_COMMANDS"] = ({}, {service, page = 0, size = 5000, query = { parameters: {} }, sort}) => {
    let targetUrl = `${service}/api/v1/commands?size=${size}&page=${page}&query=${encodeURI(JSON.stringify(query))}`;
    if(sort != undefined || sort != null) {
        targetUrl += `&sortField=${sort.sortField}&sortDirection=${sort.direction}`
    }
    return Axios.get(targetUrl)
        .then(utils.parsePageResponse)
        .then(res => res.list);
}

export default store;